/**
 * Extract a column of data specified in encoding.
 */
export var Column = function Column(_ref) {
  var value = _ref.value;
  return function () {
    return value;
  };
};
Column.props = {};